<template>
    <div class="animationload">
        <div class="circle-border">
            <div class="circle-core"></div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        loadingHide: Boolean
    },
    watch: {
        loadingHide() {
            if(this.loadingHide) {
		        $(".animationload").hide();
            }
        }
    },
}
</script>
<style scoped>
.animationload {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #fff;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    z-index: 999999;
}
.circle-border {
  width: 70px;
  height: 70px;
  padding: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: var(--theme-color);
  background: linear-gradient(0deg, rgba(255,255,255,0.1) 33%, var(--theme-color) 100%);
  animation: spin .8s linear 0s infinite;
}

.circle-core {
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-radius: 50%;
}
@keyframes spin {
  from {
    transform: rotate(0);
  }
  to{
    transform: rotate(359deg);
  }
}

</style>


// WEBPACK FOOTER //
// src/components/loading.vue